export default "__VITE_ASSET__sT5iCZfP__"